import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { exhaustCheck, KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType, VisitorType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { KameleoonLogger } from 'src/logging';

export class NewVisitor implements ICondition {
  private visitorType?: VisitorType | null;

  constructor({ visitorType }: ConditionDataType) {
    this.visitorType = visitorType;
  }

  public evaluate({
    targetingData,
    sdkInfo,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const visitsData = targetingData?.[KameleoonData.VisitsData];

    if (!visitsData || !this.visitorType) {
      return Ok(false);
    }

    const { visits } = visitsData;

    // --- Note ---
    // Second case handles situation when user didn't use `addData` that
    // creates new current visit
    const isNewVisitor = sdkInfo.isServer
      ? !visits.length
      : visits.length <= 1;

    switch (this.visitorType) {
      case VisitorType.NEW:
        return Ok(isNewVisitor);
      case VisitorType.RETURNING:
        return Ok(!isNewVisitor);
      default:
        KameleoonLogger.error`Unexpected visitor type for NewVisitor condition: ${this.visitorType}`;
        exhaustCheck(this.visitorType);
    }
  }
}
